<template>
  <v-navigation-drawer
    class="list_items"
    color="white"
    v-model="drawerComputed"
    temporary
    absolute
  >
    <!-- top list -->
    <v-list-item class="d-flex flex-column">
      <v-list-item-content class="elevation-0">
        <v-btn
          @click.stop="drawerComputed = !drawerComputed"
          elevation="0"
          fab
          small
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item-content>
      <v-list-item-content class="d-flex w-100">
        <v-btn @click="$emit('reset')" class="w-100" elevation="0">
          چت جدید
          <v-icon>mdi-forum-plus</v-icon>
        </v-btn>
      </v-list-item-content>
    </v-list-item>

    <!-- divider -->
    <v-divider />

    <!-- list chat -->

    <v-list v-for="(keys, i) in Object.keys(archive)" :key="i" dense nav>
      <v-subheader>{{ keys }}</v-subheader>
      <v-list-item v-for="item in archive[keys]" :key="item.id" link>
        <v-list-item-icon>
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-list-item-icon>

        <v-list-item-content @click="$emit('click', item.id, item.model)">
          <v-list-item-title>
            {{ item?.title ?? "مکالمه سابق" }}</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import ChatServices from "../../../../utilities/ChatServices";
import moment from "moment";

export default {
  name: "listChatBotMobile",
  props: { value: Boolean },

  data() {
    return {
      chatServices: null,
      loading: false,
      archive: [],
      test: true,
    };
  },

  computed: {
    drawerComputed: {
      get() {
        return this.mobile ? !this.value : this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    mobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },

  mounted() {
    this.chatServices = new ChatServices();
    this.getArchive();
  },

  methods: {
    async getArchive() {
      this.loading = true;
      try {
        const { data } = await this.chatServices.getAllArchiveChats();
        this.checkTime(data.data);
      } catch {
      } finally {
        this.loading = false;
      }
    },

    checkTime(data) {
      const today = moment().startOf("day");
      const yesterday = moment().subtract(1, "day").startOf("day");
      const lastWeek = moment().subtract(7, "days").startOf("day");
      const lastMonth = moment().subtract(1, "month").startOf("day");

      const times = {
        today: [],
        yesterday: [],
        lastWeek: [],
        lastMonth: [],
        older: [],
      };

      data.forEach((item) => {
        const dateStr = item.created_at;
        const date = moment(dateStr);
        if (date.isSame(today, "day")) {
          times.today.push(item);
        } else if (date.isSame(yesterday, "day")) {
          times.yesterday.push(item);
        } else if (date.isAfter(lastWeek)) {
          times.lastWeek.push(item);
        } else if (date.isAfter(lastMonth)) {
          times.lastMonth.push(item);
        } else {
          times.older.push(item);
        }
      });

      let filtersTimess = {};
      Object.keys(times).map((item) => {
        if (times[item]?.length > 0) {
          filtersTimess = { ...filtersTimess, [item]: times[item] };
        }
      });

      this.archive = filtersTimess;
    },
  },
};
</script>

<style scoped>
.list_items {
  background: white;
}
.v-list-item::after {
  display: none;
}
</style>
